import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import TextField from '@component/form/element/textfield';
import VatField from '@component/form/element/vatfield';
import CountryField from '@component/form/element/countryfield';
import FormNotification from '@component/form/element/formnotification';

const BillingInfo = ({
  companyName,
  vatNumber,
  countryCode,
  streetAndNumber,
  city,
  zipcode,
  country,
  formName,
  updateValue,
  onVatFieldResetError,
  onCountryFieldUpdate,
  getErrorMessage,
}) => {
  const onFieldChange = React.useCallback((event) =>
    updateValue(event.target.name, event.target.value)
  );

  return (
    <React.Fragment>
      <legend className="signup-form__legend">
        {I18n.t('form.account.legend.details')}
      </legend>
      <TextField
        label={
          I18n.t('form.account.label.company') +
          ' ' +
          I18n.t('form.account.label.not_required')
        }
        value={companyName}
        name="company_name"
        onChange={onFieldChange}
      />
      <FormNotification
        message={getErrorMessage('company_name')}
        type="error"
      />
      <VatField
        value={vatNumber}
        errorMessage={getErrorMessage('vat_number')}
        updateValue={updateValue}
        resetError={onVatFieldResetError}
        formName={formName}
        countryCode={countryCode}
      />
      <TextField
        label={I18n.t('form.account.label.street_and_number')}
        value={streetAndNumber}
        name="street_and_number"
        onChange={onFieldChange}
        valid={0}
      />
      <FormNotification
        message={getErrorMessage('street_and_number')}
        type="error"
      />
      <TextField
        label={I18n.t('form.account.label.city')}
        value={city}
        name="city"
        onChange={onFieldChange}
        valid={0}
      />
      <FormNotification message={getErrorMessage('city')} type="error" />
      <TextField
        label={I18n.t('form.account.label.zipcode')}
        value={zipcode}
        name="zipcode"
        onChange={onFieldChange}
        valid={0}
      />
      <FormNotification message={getErrorMessage('zipcode')} type="error" />
      <CountryField
        value={countryCode}
        defaultValue={country}
        errorMessage={getErrorMessage('country_code')}
        updateValue={updateValue}
        onUpdate={onCountryFieldUpdate}
      />
    </React.Fragment>
  );
};

BillingInfo.propTypes = {
  companyName: PropTypes.string.isRequired,
  vatNumber: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  streetAndNumber: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  updateValue: PropTypes.func.isRequired,
  onVatFieldResetError: PropTypes.func.isRequired,
  onCountryFieldUpdate: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
};

export default BillingInfo;
